import React from 'react';
import Image from 'next/image';
import RPIcon from '@assets/images/RP.svg';
import Add from '@assets/images/add-alt.svg';
import { useEvents } from '@events/EventsProvider';
import { EDU_MODULE_CLICKED } from '@constants/amplitudeEvents';
import useEducationalModule from '@hooks/useEducationalModule';

export default function EducationalModuleBanner() {
  const { track } = useEvents();
  const { toggleEducationalModuleModal } = useEducationalModule();

  const openModal = () => {
    track(EDU_MODULE_CLICKED, {});

    toggleEducationalModuleModal();
  };

  return (
    <div
      className="bg-rp-cloud cursor-pointer flex h-12 items-center justify-between max-w-1024 outline-none pl-15px pr-3 rounded-xl text-rp-neutral w-full z-20"
      onClick={openModal}
      onKeyDown={openModal}
      role="button"
      tabIndex={0}
    >
      <div className="flex items-center space-x-3">
        <div className="flex-shrink-0 h-13px w-4.5 relative">
          <Image src={RPIcon} alt="Decorative" layout="fill" />
        </div>

        <div>
          <p className="font-rp-pn-semi-bold text-sm leading-14px">
            Join over 5 million guests on ResortPass
          </p>
        </div>
      </div>

      <div className="flex flex-row space-x-3">
        <div className="hidden d:block">
          <p className="font-rp-pn-semi-bold text-sm leading-14px">Learn more</p>
        </div>

        <div className="flex-shrink-0 h-4 w-4 relative">
          <Image src={Add} alt="View" layout="fill" />
        </div>
      </div>
    </div>
  );
}
